import React, { useEffect, useState } from 'react';
import styles from './Dashboard.module.scss';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { Dispatch } from 'redux';
import classnames from 'classnames';
import { get, isEmpty } from 'lodash';
//charts
import { BarChart } from './Charts/user-stats/BarChart';
import { LineGraph } from './Charts/user-stats/LineGraph';
import { StatsTable } from './Charts/user-stats/StatsTable';
//assets
import SVG from 'react-inlinesvg';
import dropdown from '../../assets/dropdown.svg';

//data
import { DashboardState } from '../../store/dashboard/reducer';
import { LoginState } from '../../store/login/reducer';
import { dashboardActions } from '../../store/dashboard/actions';
//functions
import { periodFilterValues, getSinceDate } from './Utils/dashboardUtils';
//Tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';
import { useAnalyticsHandlers } from '../../analytics/__providers__/AnalyticsHandlersProvider';

export interface StateProps {
  loading: boolean;
  dashboardState: DashboardState;
  loginState: LoginState;
}
export interface DispatchProps {
  getStats: (queryparams: any) => any;
}
type StatsProps = StateProps & DispatchProps;

export const Stats: React.FC<StatsProps> = (props) => {
  const { t } = useTranslation();
  const analytics = useAnalyticsHandlers();
  const cx = classnames.bind(styles);
  const [isOpenPeriodFilter, setIsOpenPeriodFilter] = useState(false);
  const [periodFilter, setPeriodFilter] = useState({
    key: 'HISTORIC',
    label: tr(t, 'HISTORIC'),
  });
  const { getStats, dashboardState, loginState } = props;
  const userId = get(loginState, ['user', 'user', 'id']);
  useEffect(() => {
    getStats({
      period_filter: periodFilter.key,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    analytics!.client.BIEvent.log('STATS_PAGE_VISITED', {
      values: [{ additional_info: `${periodFilter.key}` }],
      userID: userId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodFilter]);
  const handlePeriodFilter = (filter: any) => {
    setPeriodFilter(filter);
    !dashboardState.isLoading &&
      getStats({
        period_filter: filter.key,
      });
    setIsOpenPeriodFilter(false);
  };
  const EmptyState = (type: any) => {
    if (dashboardState.isLoading) {
      return (
        <label className={styles.emptyState}> {tr(t, 'loading')}...</label>
      );
    } else if (isEmpty(dashboardState.statsSummary[type])) {
      return <label className={styles.emptyState}> {tr(t, 'no-data')}</label>;
    }
  };

  return (
    <div className={styles.container} id={styles.stats}>
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <div>
            <label>{tr(t, 'stats')}</label>
            <h1>{tr(t, 'users')} (Beta)</h1>
            <label>{getSinceDate(periodFilter.key, t)}</label>
          </div>

          <div
            className={
              isOpenPeriodFilter
                ? cx(styles.dropdown, styles.showLess)
                : cx(styles.dropdown, styles.showMore)
            }
          >
            <button onClick={() => setIsOpenPeriodFilter(!isOpenPeriodFilter)}>
              {tr(t, periodFilter.label)}
              <SVG src={dropdown} />
            </button>

            <div
              className={
                isOpenPeriodFilter
                  ? cx(styles.expanded, styles.dropdownItems)
                  : cx(styles.collapsed, styles.dropdownItems)
              }
            >
              {periodFilterValues.map((filter) => {
                return (
                  <label
                    key={filter.key}
                    onClick={() => handlePeriodFilter(filter)}
                  >
                    {tr(t, filter.label)}
                  </label>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.divisionLine}></div>
      {/* <div className={cx(styles.section, styles.topSection)}>
        <div className={styles.subHeader}>
          <div>
            <h2>{tr(t, 'visits')}</h2>
          </div>
        </div>
        <div className={cx(styles.chartWrapper, styles.fullChart)}>
          <LineGraph
            data={dashboardState.statsSummary.channel_visits}
            label={tr(t, 'visits')}
            periodFilter={periodFilter}
          />

          {EmptyState('channel_visits')}
        </div>
      </div> */}
      <div className={styles.flexSection}>
        <div className={styles.section}>
          <div className={styles.subHeader}>
            <div>
              <h2>{tr(t, 'new-followers')}</h2>
            </div>
          </div>
          <div className={cx(styles.chartWrapper, styles.halfChart)}>
            <BarChart
              data={dashboardState.statsSummary.new_followers}
              label={tr(t, 'new-followers')}
              periodFilter={periodFilter}
            />

            {EmptyState('new_followers')}
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.subHeader}>
            <div>
              <h2>{tr(t, 'followers')}</h2>
            </div>
          </div>
          <div className={cx(styles.chartWrapper, styles.halfChart)}>
            <LineGraph
              data={dashboardState.statsSummary.total_followers}
              label={tr(t, 'followers')}
              periodFilter={periodFilter}
            />

            {EmptyState('total_followers')}
          </div>
        </div>
      </div>
      <div className={styles.flexSection}>
        <div className={styles.section}>
          <div className={styles.subHeader}>
            <div>
              <h2>{tr(t, 'country')}</h2>
            </div>
          </div>
          <div className={cx(styles.chartWrapper, styles.halfChart)}>
            <StatsTable
              data={dashboardState.statsSummary.countries}
              label={'countries'}
            />

            {EmptyState('countries')}
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.subHeader}>
            <div>
              <h2>{tr(t, 'language')}</h2>
            </div>
          </div>
          <div className={cx(styles.chartWrapper, styles.halfChart)}>
            <StatsTable
              data={dashboardState.statsSummary.languages}
              label={'languages'}
            />

            {EmptyState('languages')}
          </div>
        </div>
      </div>
      {/* <div className={styles.section}>
        <div className={styles.subHeader}>
          <div>
            <h2>{tr(t, 'notifications')}</h2>
          </div>
        </div>
        <div className={cx(styles.chartWrapper, styles.fullChart)}>
          <StatsTable
            data={dashboardState.statsSummary.notifications_config_mode}
            label={'notifications_settings'}
          />

          {EmptyState('notifications_config_mode')}
        </div>
      </div> */}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  dashboardState: state.dashboard,
  loginState: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getStats: (queryparams: any) =>
    dispatch(dashboardActions.statsRequestAction(queryparams)),
});

export const StatsConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Stats);
